const floor = (n, m = 0) => {
  return Math.floor(n * Math.pow(10, m)) / Math.pow(10, m);
};

export default floor;
